import { Container, Row, Col } from 'react-bootstrap';
import { CardWithLeftImage } from '../../../Components/Card';
import {
  HeadingDescSmall,
  SectionInnerHeading
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import distance from '../../../assets/images/svg/distance.svg';
import desentLighting from '../../../assets/images/svg/desent-lighting.svg';
import keepItSteady from '../../../assets/images/svg/keep-it-steady.svg';
import { SimpleAncerSmall } from '../../../Components/button';
import AddMember from '../../../Components/addMember/AddMember';
import './startVitalScan.css';

function StartVitalScan() {
  return (
    <HealthCheckLayout>
      <section className="startVitalScan bgLinghtGray">
        <Container>
          <Row>
            <Col md={8}>
              <div className="leftBox whiteBox">
                <SectionInnerHeading text="Before we start, please make sure to:" />
                <CardWithLeftImage
                  image={distance}
                  heading="Distance:"
                  desc="Place your phone against something or hold it steady in your hand while the optimal distance is about 30-50 cm."
                />
                <CardWithLeftImage
                  image={desentLighting}
                  heading="Decent Lighting:"
                  desc="Make sure there is no bright source of light behind the head when measuring through on selfie mode"
                />
                <CardWithLeftImage
                  image={keepItSteady}
                  heading="Keep it Steady:"
                  desc="Look at the screen during the whole recording and avoid movements as much as possible"
                />
                <SimpleAncerSmall text="start the scan" />
              </div>
            </Col>
            <Col md={4}>
              <div className="rightBox">
                <div className="whiteBox">
                  <AddMember />
                </div>
                <hr />
                <div className="whiteBox">
                  <HeadingDescSmall text="Your Vitals" />
                  <HeadingDescSmall text="The HealthCheck Scan will last for 90 second before it can show you the vitals." />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default StartVitalScan;
